import { fetchEntity } from './entity';

export const fetchMessage = ({ id }) => fetchEntity({ id, entityName: 'messages', fetchUrl: '/api/wallet/private_message/get' });
